<!--
  PromptSearchForm.vue
  프롬프트 검색 및 필터링 폼 컴포넌트
-->
<template>
  <div class="search-container">
    <div class="search-form">
      <div class="search-row">
        <div class="search-group">
          <label>검색 조건</label>
          <a-select v-model:value="searchForm.type" style="width: 150px">
            <a-select-option value="promptCode">프롬프트 코드</a-select-option>
            <a-select-option value="promptName">프롬프트명</a-select-option>
          </a-select>
        </div>
        
        <div class="search-group">
          <label>검색어</label>
          <a-input
            v-model:value="searchForm.keyword"
            placeholder="검색어를 입력하세요"
            @pressEnter="handleSearch"
            style="width: 300px"
          />
        </div>
        
        <div class="search-actions">
          <a-button 
            type="primary" 
            @click="handleSearch"
            :loading="loading"
          >
            <i class="fa fa-search" style="margin-right: 5px"></i>검색
          </a-button>
          
          <a-button @click="handleReset">
            <i class="fa fa-refresh" style="margin-right: 5px"></i>초기화
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, watch } from 'vue';

// 상수 정의
const SEARCH_TYPES = {
  PROMPT_CODE: 'promptCode',
  PROMPT_NAME: 'promptName'
};

export default {
  name: 'PromptSearchForm',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search', 'reset'],
  setup(props, { emit }) {
    // 검색 폼 데이터
    const searchForm = reactive({
      type: SEARCH_TYPES.PROMPT_CODE,
      keyword: ''
    });

    // 검색 실행
    const handleSearch = () => {
      emit('search', { ...searchForm });
    };

    // 검색 초기화
    const handleReset = () => {
      searchForm.type = SEARCH_TYPES.PROMPT_CODE;
      searchForm.keyword = '';
      emit('reset');
    };

    // 검색 폼 변경 감지
    watch(searchForm, () => {
      // 자동 검색은 부모 컴포넌트에서 결정
    }, { deep: true });

    return {
      searchForm,
      handleSearch,
      handleReset,
      SEARCH_TYPES
    };
  }
};
</script>

<style scoped lang="scss">
// 검색 컨테이너
.search-container {
  padding: 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fff;
}

.search-form {
  .search-row {
    display: flex;
    align-items: end;
    gap: 16px;
    flex-wrap: wrap;
  }
  
  .search-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    
    label {
      font-weight: 500;
      font-size: 14px;
      color: #262626;
    }
  }
  
  .search-actions {
    display: flex;
    gap: 8px;
  }
}

// 반응형 스타일
@media screen and (max-width: 768px) {
  .search-row {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }
  
  .search-actions {
    justify-content: center;
  }
}
</style> 